export default {
	category: {
		placeholder: 'Type keywords',
		edit: 'Edit',
		delete: 'Delete',
		noResult: 'No result',
		noCategory: 'No category',
		changeKey: 'Try another keyword',
		changeKeyCategory: 'Go to the recommendation center',
		deleteTitle: 'Tips',
		deleteContent: 'Are you sure you want to delete this skill?',
		deleteConfirm: 'Confirm',
		deleteCancel: 'Cancel',
		deleteSuccess: 'Delete success',
		add: 'add',
		name: 'Prompt',
		noSearch: 'You have not create any agent',
		noSearch1: 'Not create any agent,Please create an agent on the PC',
		editName: 'Rename Dialogue',
		info: 'Conversations moved here~',
		info1: 'I know',
		info2: 'Saved changes',
		info3: 'Already removed',
		deepThink: 'DeepThink',
		tip: 'Solve the problem',
		tipHead: 'Deep thinking is online',
		tipMes: 'Good at deep thinking to solve reasoning problems',
		infoToast: 'Deepmind does not support uploading files',
		infoToast1: 'Continue to switch the uploaded file will be deleted',
	},
	center: {
		placeHolder: 'Please type your question, Enter send, Shift Enter wrap line',
		continueText: 'More answer, ',
		continueButton: 'Continue',
		chatLog: 'Conversation',
		chatDia: 'Dialogue',
		chatProduction: 'Production',
		hello: "Hello, I'm YaYi",
		answer: 'You can ask me one of the following questions:',
		change: 'Click to change',
		stop: 'Stop generating',
		reopen: 'New chat will be created for more topics',
		deepThinkOpen: 'This reasoning is over. A new dialogue is about to open',
		sensitiveTitle: 'You triggered some security-audit mechanism, the system will create a new conversation before the next chat.',
		reference: 'The content is AI generated for reference only',
		role: 'Agent',
		YaYi: 'YAYI',
		detail: 'Detail',
		callPlugin: 'Plugin',
		pluginTime: 'Elapsed',
		pluginResult: 'Plugin Output',
		edit: 'Edit',
		copy: 'Copy',
		share: 'Share',
		alreadyCopy: 'Already Copy',
		regenerate: 'Regenerate',
		tip: 'The content is generated by AI and does NOT represent our attitudes, please distinguish carefully.',
		submit: 'Submit',
		up: 'Thumbs-up',
		down: 'Thumbs-down',
		alreadyDown: 'Already Thumbs-down',
		example: 'Example Code',
		play: 'Play',
		alsoAsk: 'You can also ask:',
		changeQuestion: 'Change',
		copyCode: 'Copy Code',
		clickUpSuccess: 'Thumbs-up success',
		clickDownSuccess: 'Thumbs-down success',
		reportSuccess: 'Report has been submitted, thank you for your feedback',
		copySuccess: 'Copy success',
		cannotUp: 'Cannot thumbs-up',
		cannotDown: 'Cannot thumbs-down',
		generateAnswer: '{name} is generating answers for you...',
		generateAnswerHK: 'D2 is generating answers for you...',
		themeChange: 'Theme Change',
		collapse: 'Collapse',
		expand: 'Expand',
		hiddenLines: '{n} lines hidden',
		waitForComplete: 'Please wait for generation to complete',
		source: 'Source',
		refer: 'Refer',
		startConnection: 'Establishing a connection',
		endConnection: 'Closing a connection',
		startRecord: 'Start recording',
		recording: 'Recording',
		assistantPlaceholder: 'Enter "/" to select a predefined prompt. You can also try pasting the link directly',
		assistantPlaceholder1: 'Send message to {name}, Enter send, Shift+Enter line wrap',
		textPlaceHolder: 'Ask me anything',
		selectedContent: 'Selected content:',
		unfold: 'Unfold',
		doWhat: 'What do you want to do with this sentence?',
		uploadFinish: 'Upload finish',
		pluginTip: 'No plugins currently available',
		confirmParse: 'Confirm parse',
		pageReadAnalyse: 'Analysis of web page reading',
		// pageReadAnalyseTip: 'Answer accurately according to the web page, no more than 128k',
		pageReadAnalyseTip: 'Answer accurately according to the web page, no more than 200,000 words',
		pageReadPlaceholder: 'Please enter URL',
		imgAnalyse: 'Image intelligent analysis',
		imgTip: 'Jpg, jpeg, png images are supported',
		docReadAnalyse: 'Analysis of Document reading',
		// docReadAnalyseTip: 'Support parsing pdf and txt files, no more than 128k',
		docReadAnalyseTip: 'Support parsing pdf and txt files, no more than 200,000 words',
		parseError: 'Parse failed: content is too long',
		allowFileType: 'Only allow upload file type:',
		fileSizeMoreThan10: 'File: {name} exceeds 20M, please process it and upload it again',
		fileSizeMoreThan1024: 'File: {name} exceeds 1GB, please process it and upload it again',
		promptCheck: 'Prompt View',
		addConversation: 'New Chat',
		tryExample: 'Click to try',
		just: 'Just Now',
		seconds: 's',
		minutes: 'min',
		hours: 'h',
		days: 'days',
		ago: ' ago',
		ready: 'Searching for network information',
		running: 'Reading online materials',
		pageSummary: 'Read web pages and summarize',
		pageKBSummary: 'Read knowledge and summarize',
		bingSearch: 'Online query:',
		fileSearch: 'Knowledge Query:',
		onLineSearchTitle: 'Query {name} times, a total of {num} related files are retrieved, click to view details',
		toastTitle: 'Currently, uploading pictures and documents at the same time is not supported',
		toastTitle1: 'Uploading pictures and adding web pages is not supported',
		toastContent: 'If you continue to upload the image will overwrite the uploaded file',
		toastContent1: 'If you continue to upload the file will overwrite the uploaded image',
		okText: 'Overlay and upload',
		about: 'About {num} word',
		repeatInfo: '{url} Duplicate. Please delete the duplicate URL',
		existInfo: '{url} parsed, please re-enter',
		info: 'The maximum number of parses is 10',
		info1: 'The number of files cannot exceed 10',
		info2: 'The number of images cannot exceed 3',
		info3:'Only one file can be uploaded',
		fileValueInfo: 'The link address cannot be empty',
		wordsLimit: 'Word limit exceeded, please delete before sending',
		sendMessage: 'Please enter the question before sending',
		errMessage: 'Abnormal files exist. Please process them and send them again',
		failMessage: 'Parsing failure',
		failMessage1: 'Sensitivity involved',
		failMessage2: 'Upload failure',
		loadingStatus: 'Web search underway',
		name: 'Sub-problem{num}:',
		allSelect: 'select all',
		preview: 'Preview',
		shareChat: 'Share a conversation',
		chat: 'Immediate session',
		copyUrl: 'Copy share link',
		copySuccess1: 'Copy the link, share it now~',
		noSelect: 'Please first select the message you want to share',
		shareInfo: 'The content of the conversation is automatically generated by AI and does not represent official attitudes or views',
		goToChat: 'Discover more at  YAYI',
		wordsCountTip: 'If you exceed the word limit, please ask questions based on the first 200,000 words.',
		// linkInfo:"【YAYI】This is my chat with {name}, you can try it~ 【Click the link to open directly or copy the content to YAYI APP to open directly】",
		// linkInfo2: "【YAYI】This is the result of my search in YAYI AI Search, you can try it~ 【Click the link to open directly or copy the content to YAYI APP to open directly】",
		// linkAgentInfo: "【YAYI】 This is the agent 「{name}」 I share, you can also try it ~ [Click the link to open directly or copy the content to YAYI APP to open directly]",
		linkInfo: '【YAYI】This is my chat with {name}, you can try it~ 【Click the link to open directly】',
		linkInfo2: '【YAYI】This is the result of my search in YAYI AI Search, you can try it~ 【Click the link to open directly】',
		linkAgentInfo: '【YAYI】 This is the agent 「{name}」 I share, you can also try it ~ 【Click the link to open directly】',
		shareMessage: 'Scan code to download YAYI APP',
		pluginsResult: 'No plug-in',
		linkText: 'Click on the link to view the conversation with YAYI',
		noData: 'The session cannot be viewed temporarily',
		chatIng: 'The dialogue is currently underway',
		uploadTitle: 'Drag the file here to upload it',
		uploadInfo: 'Supported upload types: doc, docx, pdf, txt, md, jpg, jpeg, png',
		uploadInfo1: 'Supporting up to 10 files (20MB each).',
		uploadInfo5: 'Supporting up to 1 file (20MB each).',
		uploadInfo2: 'Accept formats: {name} etc.',
		uploadInfo4: 'Accepted formats: .pdf/.doc/.docx/.xls/.xlsx/.ppt/.pptx/.txt/.png/.jpg',
		uploadInfo6: 'Accepted formats: .pdf/.docx/.xls/.xlsx/.pptx/.txt/.png/.jpg/.csv/.md/.epub/.wps',
		img: 'Image',
		uploadInfo3:
			'The uploaded file contains an unsupported file format. Please convert the file format and try again. Supported file formats: {name}, etc',
		loading: 'Uploading',
		pluginInfo1: 'The plug-in is enabled. YAYI will intelligently invoke the plug-in to solve the problem',
		pluginInfo2: 'The plug-in is closed, and questions will be answered directly by the YAYI Model',
		pluginInfo3: 'After uploading a file or website, the plugin is automatically closed',
		plugin: 'plugin',
		new: 'Recent',
		collect: 'Marked',
		noCollect: 'No Marked Conversations',
		collectChat: 'Mark this conversation',
		collected: 'Marked',
		noKnowList: 'No knowledge base',
		noKnowListInfo: 'Please go to the knowledge base to create and add',
		resultInfo: 'The code answer has been',
		resultIng: 'Code is being analyzed and generated',
		outlineInfo: 'Outline has been generated',
		outlineIng: 'Generating outline',
		thinkDone: 'Thinking complete',
		deepthinkInfo: 'Thought completed',
		deepthinkIng: "I'm thinking about it",
		deepthinkIng1: 'Generating...',

		result: 'Result',
		searchWeb: 'Search Web',
		bottomInfo: 'Generated by AI, only for reference and inspiration.',
		wenge: 'Wenge Ltd.',
		agentCenter: 'Agent Center',
		linkInfo1: 'Visit YaYi Open-Source Community',
		nameYayi: 'YaYi',
		like: 'Good response',
		nolike: 'Bad response',
		preViewInfo: 'Preview is not currently supported',
		loadingPreViewInfo: 'The file is uploaded, and preview is not supported',
		loadingPreViewInfo1: 'The file is parsing, and preview is not supported',
		failPreViewInfo: 'File upload failed. Preview is not supported',
		infoMessage: '(Partially captured)',
		aiSearchPlace: 'The network information search',
		searchPlace: 'Please enter a question...',
		from: 'Shared',
		share1: '',
		chatAgain: 'Chat',
		deleteInfo: 'The agent has been deleted and cannot hold a conversation',
		deleteInfo1: 'The agent has been deleted and cannot hold a conversation',
		deleteInfo2: 'The agent is offline and cannot hold a conversation',
		referenceSources: 'Reference sources',
		ask: 'Ask',
		writerInfo: 'Using YaYi Writer professional AI for writing',
		editTheQuestion1: 'You have stopped this search. You can',
		editTheQuestion2: 'edit the question',
		editTheQuestion3: 'and repost it.',
		stageSteps1: 'Problem analysis',
		stageSteps2: 'Data retrieval',
		stageSteps3: 'Answer summary',
		answerNodata1: 'No relevant information was retrieved from the source you selected, please',
		answerNodata2: 'Edit question',
		answerNodata3: 'or',
		answerNodata4: 'Select another source',
		answerNodata5: 'Restart search later',
		resultTotal: 'Summary',
		textTruncation: "The file is too long. Some of it's been intercepted",
		tipName: 'The name cannot be empty',
		selectLabel: 'Please Select Report Type',
		historyPlace: 'Search conversation title...',
		historyPlace1: 'Search Task title...',
		historyPlace2: 'Search History...',

		you: 'You',
		clear: 'Clear',
		time: 'Time',
		noproductionInfo: 'You have not yet generated a work',
		noproductionInfo1: 'Look forward to your wonderful content',
		name1: 'Long writing',
		resultInfo1: 'The resulting results',
		record: ' in Records - Works',
		check: 'can be viewed',
		longWrite: 'Long Text',
		fail: 'Fail',
		loadingInfo: 'Running',
		pendingInfo: 'Pending',
		editName: 'rename',
		public: 'publish',
		checkHistory: 'View in conversation',
		noLink: 'Link has failed',
		proDetail: 'Task Details',
		infoSend: 'The link is unavailable and the conversation cannot proceed',
		historyTitle: 'Records',
		parsing: 'Parsing',
		fileTypeError: 'Please upload the correct format',
		onlyPdfLiterature: 'Currently only supports academic literature in .pdf/.docx/.doc format, please re-upload',
		posterLiterature: 'Currently only supports academic literature in .pdf/.docx/.doc/.txt/.md format, please re-upload',
		confirm:'Pending',
		playback: 'View replay'
	},
	record: {
		record: 'Convo',
		recordTip: 'Chat conversations',
		assistant: 'VDP',
		assistantTip: 'Virtual Digital Person',
		noMore: 'No more',
		confirm: 'Confirm',
		deleteChat: 'Are you sure you want to delete this conversation?',
		noChatRecord: 'No conversation record',
		yayiAssistant: 'YaYi Assistant',
		chatName: 'Conversation name cannot be empty',
		startSound: 'Turn on the sound',
		closeSound: 'Turn off the sound',
		noChatRecord1: 'No search oh, go ask Research!',
		btn: 'New Chat',
		loading: 'Loading...',
		nodata: 'You have not yet generated a Task',
		nodata1: 'Look forward to your wonderful content',
		deleteChat1: 'Are you sure to delete this task?',
	},
	prompt: {
		exit: 'Exit',
		cancel: 'Cancel',
		confirmExit: 'Are you sure you want to exit?',
		exitTips: 'The current content will not be saved after exiting',
		createSkill: 'Create Skill',
		editSkill: 'Edit Skill',
		basicSkill: 'Basic configuration',
		skillName: 'Skill name',
		skillNamePlaceholder: 'Please enter skill name',
		placeholder: 'Please enter',
		placeholderSelect: 'Please select',
		category: 'Category',
		skillBrief: 'Skill brief',
		templatePlaceholder: 'Please enter template content',
		role: 'Role',
		rolePlaceholder:
			'Please enter the identity, such as: financial expert, with 10 years of industry experience, is a senior financial expert, with the ability to analyze and summarize the financial field on the spot, can do professional analysis of emerging industries such as finance, stock market, media, Internet, etc.',
		recommendedQuestions: 'Prompt',
		promptEmptyPlaceholder: 'Please enter prompt',
		promptPlaceholder:
			"Enter a prompt template with interpolation parameters defined using braces {'{}'}. The template must contain 2 to 30 characters, which can be letters, numbers, and underscores ('_'), and cannot merely contain numbers. Example: Article content: {'{'} article{'}'}, please create a summary of up to {'{'}number{'}'} characters.",
		variable: 'Variables',
		variablePlaceholder: 'Please enter variable example value',
		noData: 'No data available',
		creativity: 'Creativity',
		save: 'Save',
		debug: 'Debug',
		promptPreview: 'Prompt Preview',
		promptPreviewTip: 'Enter a prompt in the left field for real-time preview',
		run: 'Run',
		result: 'Result',
		time: 'Time',
		takeToken: 'Cost Token',
		generateResult: 'Result generating...',
		variableName: 'Variable Name',
		type: 'Type',
		example: 'Example',
		string: 'String',
		newSkills: 'New Skill',
		editSkills: 'Edit Skill',
		examples: 'Application example promptt',
		skillNameFirstTip: 'Please enter the skill name first',
	},
	store: {
		bgRoleName: 'YaYi',
		errorText: 'Sorry, the service is too hot. Please try it later.',
		errorText1: 'There seems to be a problem with your network connection, please check your network settings and try again.',
		errorText2: 'The current service load is high, please try again later.',
		stopGenerate: 'Stop generating',
		loginInvalidation: 'This device login has expired',
		loginAgain: 'Please login again',
		loginAgainBtn: 'Login again',
		caiFormTitle: 'Your feedback is of great significance to us, your opinion',
		caiFormPlaceholder: 'What do you think is a more ideal answer?',
		zanFormTitle: 'Your feedback is of great significance to us, your opinion',
		zanFormPlaceholder: 'What surprises have I brought you?',
		report: 'Report',
		type: 'Report Type',
		desc: 'Description',
		placeHold: 'Please enter content',
	},
	temperature: {
		temperature: 'creativity',
		title:
			'Creativity refers to the “temperature” parameter of the model in generating answers. This parameter can affect the answer freedom of large models.',
		lowTitle: 'When creativity is low',
		lowDescribe: 'The model will be more cautious and avoid producing answers that are too aggressive or risky.',
		hightTitle: 'When creativity is high',
		hightDescribe: 'Models will be more open to trying new and unusual answers.',
		temperatureType1: 'Rigorous',
		temperatureType2: 'Fairly',
		temperatureType3: 'Unconstrained',
	},
	role: {
		edit: 'Edit',
		delete: 'Delete',
		add: 'Add',
		deleteCancel: 'Cancel',
		cancel: 'Cancel',
		neverCrate: 'You have not yet created a prompt',
		createImmediate: 'Create',
		debug: 'Debug',
		variableName: 'Key',
		type: 'Type',
		example: 'Value',
		default: 'Default',
		save: 'Save',
		confirmExit: 'Are you sure you want to exit?',
		exitTips: 'The current content will not be saved after exiting',
		exit: 'Exit',
		createAssistant: 'New Agent',
		roleAssistant: 'Roles',
		roleAssistantDes:
			'Create a new role to bring out domain experts, by specifying the backgroud informations(system info). The professionalism, answering style, inquiry strategy and other information, can be specified to make roles match your definition, and provide comprehensive and professional response.',
		skillAssistant: 'Skills',
		skillAssistantDes:
			'Create a new skill to assign the response boundaries, limitations, and other conditions to make the model output controllable results. You can experience summary, translation, extraction, multimodal content understanding and generation skills, powered by the generation capability from yayi.',
		exitAssistant: 'Quit',
		helloRole: 'Hello, I am ',
		deleteDes: 'If this role is deleted, all related conversation records will be deleted and cannot be restored.',
		createRoleAssistant: 'New Role',
		EditRoleAssistant: 'Edit Role',
		avatar: 'Icon',
		roleName: 'Name',
		entryRoleName: 'Please input Name',
		placeholderRoleName: 'Recommend interviewers and legal experts',
		roleNameTip: 'displayed name of the role.',
		roleDesc: 'Description',
		entryRoleDesc: 'Please input Description',
		placeholderRoleDesc:
			'I am your media assistant Xiao Ming, who can help you write real-time news articles and other news articles. We are available 24 hours a day to assist you',
		roleDescTip: 'description can be displayed in the role list.',
		AIRecommend: 'AI Suggestion',
		openingRemarks: 'Prologue',
		entryOpeningRemarks: 'Please input prologue',
		placeholderOpeningRemarks: 'Hello, I am your customer service FAQ assistant. You can ask me this',
		openingRemarksTip: 'the first sentence of the role, when you create a new conversation.',
		systemPreset: 'System Info',
		entrySystemPreset: 'Please input System Info',
		placeholderSystemPreset:
			"You are a professional interviewer, and humans are your candidates. Humans will send the names of the positions that need to be interviewed, and then you will conduct interviews with humans through multiple rounds of Q&A based on the positions. \nRequirements: \n1 You need to communicate with the candidate in Chinese; \n2 You only need to ask the interviewer one question at a time; \n3 After six rounds of Q&A with the candidate (i.e. after the candidate answers the sixth question), you need to give an interview evaluation based on the candidate's response.",
		systemPresetTip: 'system can act as the role you specified, the more accurate, the more professional.',
		questionItemExp: 'Preset questions',
		questionItemExpTip: 'questions displayed in the role, for one-click chat experience.',
		expTitle: 'Title',
		PromptRecommend: 'Prompt recommend',
		input: 'Please input…', // input:"Please enter",
		promptPlaceholder:
			"Enter a prompt template with interpolation parameters defined using braces {'{}'}. The template must contain 2 to 30 characters, which can be letters, numbers, and underscores ('_'), and cannot merely contain numbers. Example: Article content: {'{'} article{'}'}, please create a summary of up to {'{'}number{'}'} characters.",
		plugins: 'Default plugin',
		debugTitle: 'Preview',
		debugTip: 'Setting agent info on the left, then debug preview.',
		expQuestion: 'Example Question',
		addMsg: 'Add successfully',
		editMsg: 'Edit successfully',
		edmitMsg: 'Commit failure', //
		examplePrompt: 'Example Prompt',
		configDelete: 'Are you sure to delete the role ',
		configRemove: 'Confirm to remove the agent',
		talk: 'You can talk to me now~',
		string: 'String',
		searchPlaceholder: 'Search Keywords...',
		pluginsTip: 'The YaYi will determine which plugin in the library to call based on your question to answer',
		presetOne: 'Present one',
		presetTwo: 'Present two',
		presetThree: 'Present three',
		enterName: 'Please enter the role name first',
		enterIntroduction: 'Please enter the character name and introduction first',
		completeSample: 'Please enter the complete sample content before adding it',
		promptList: 'Prompt',
		agentAll: 'Public',
		agentHot: 'Hot',
		agentMy: 'My',
		agentName: 'Agent',
		infoMessage: 'File in upload or parsing please try again later!',
		linkInfo: 'Link duplication',
		fileInfo: 'File duplication',
		infoWords: 'The introduction is limited to 500 words',
		pluginsInfo: 'Please select plug-in',
		lineCheck: 'Network query:',
		ready: 'In-depth analysis of the problem',
		running: 'Problem analysis completed, search',
		finish: 'Reading the page summary',
		arrow1: 'unfold',
		arrow2: 'Pack up',
		null: 'Cannot be empty',
		refreshInfo: 'Refresh debugging',
		select: '{name}has been added',
		noselect: '{name}has been deleted',
		chat: 'New Chat',
		serach: 'AI Search',
		file: 'Chat File',
		uie: 'UIE',
		placeholder: 'Please input the default value',
		write: 'AIWrite',
		func1:'科研助手',
		flash: 'Deep Survey',
		publicInfo: 'Publish',
		publicInfo1: 'No login required, open to use',
		ignore: 'No prompt next time',
		create: 'Create Link',
		info: 'The link has been copied and in',
		info1: 'Release Management',
		info2: 'And Manage records',
	},
	notice: {
		activityTitle: 'Join Activities',
		activityContent: 'Earn bonus coins by joining events or inviting friends',
		activityButton: 'Join Now',
		upgradeTitle: 'Upgrade Plan',
		upgradeContent: 'Get more coins with a monthly/annual subscription',
		upgradeButton: 'Upgrade',
	},
	recharge: {
		fees: 'Arrears of fees',
		noiceTitle: 'Balance reminder',
		noiceTip: 'to avoid affecting your normal use, it is recommended that you recharge your account first.',
		later: 'later',
		goRecharge: 'go recharge',
		insufficientBalance: 'Insufficient balance',
		message1: 'deduction for this service call',
		message2: 'your account currently has balance',
	},
	addRole: {
		limitUpload: 'Add a maximum of three  questions',
		select: 'Avatar selection',
		model: 'model',
		file: 'Knowledge file',
		upload: 'Upload',
		info: 'Supported file type:.doc.doc.PDf.txt Markdown... Up to ten',
		about: 'about',
		text: 'word',
		desc: 'Describe your agent in one sentence',
		desc1: 'Top Mode',
		placehold: 'Please enter a description',
		desText: 'Description',
		add: 'Generate the agent configuration',
		addUrl: 'Add URL',
		limit: 'Limit 10',
		address: 'URL address',
		cancel: 'Cancel',
		confrim: 'Confirm',
		exapmle:
			'As a public opinion analyst, you can analyze the market effect of the hot information provided by the user, summarize and summarize the reasons for the occurrence and the results of the event. If there are participants, please list them together.',
		info1: 'Please enter URl',
		info2: 'Upload a maximum of 10 files',
		info3: 'Upload a maximum of 10 Urls',
		status1: 'Up pass...',
		status2: 'In analysis...',
		status3: 'Fail',
		intell: 'Agent',
		all: 'All',
		hot: 'Hot',
		my: 'My',
		technologySet: 'Example configuration',
		kowledge: 'Knowledge base configuration',
		base: 'Basic',
		setting: 'Ability',
		addExample: 'Add example',
		uploadUrl: 'Add URL',
		uploadKnowledge: 'Associated knowledge base',
		selected: 'Selected',
		selectedName: 'Files',
		placeHolder: 'Keyword search',
		answerModel: 'Answer model',
		v2: 'Intelligent',
		v3: 'Search',
		vInfo: 'When no plug-in is selected, you can only answer questions directly through the YAYI Grand model',
		v2Info: 'Determine which plug-in answers need to be called based on the question',
		v3Info: 'The problem is broken down into sub-problems, and then network search is carried out',
		selctPlugin: 'Optional',
		creatSet: 'creativity',
		infoSubmit: 'Complete basic configurations first',
		pluginInfo1: 'Access the Internet to retrieve information',
		pluginInfo2: 'Perform mathematical operations with the help of a calculator',
		pluginInfo3: 'Support weather query for the next 7 days (including the same day)',
		pluginInfo4: 'Obtain the latest hotspot information about a specific topic based on the network popularity',
		pluginInfo5: 'Generate and execute code to get precise results such as math operations, chart drawing, Md table questions and answers',
		pluginInfo6: 'Generate an outline and 10,000 word long text in steps',
		gotoFile: 'File',
		modelTitle: 'Advanced search does not support mounting knowledge',
		modelInfo: 'If you continue to switch modes, the selected knowledge becomes invalid',
		modelInfo1: 'You can also check the "Networking" in "Smart Mode" to achieve the networking function of the agent',
		continue: 'continue',
		edit: 'Edit',
		remove: 'Remove',
		auxiliary: 'Accessibility Features',
		open: 'Enable',
		close: 'Disable',
		baseInfo: 'Basic',
		appendFun: 'Extended',
		redAnaly: 'Attach Files',
		readTitle: 'File Reading Manual',
		readInfo: 'Interpret files sent by users to answer questions',
		fileType: 'Limit File Types',
		webAnaly: 'Attach Webpages',
		webTitle: 'Webpage Reading Manual',
		webInfo: 'Analyze the content of web links sent by users to answer questions',
		preQuestion: 'Preset',
		addQuestion: 'Add',
		questionTitle: 'Name',
		questionTitleInfo: 'If not filled, will display the content',
		questionCintentInfo: "added to the question by entering '{'{}'}', for example:'{'{'}content{'}'}'",
		placeHold1: 'Enter the preset issue button name displayed in the Agent',
		placeHold2: 'The content of the message you want to send',
		content: 'Content',
		name: 'Name',
		state: 'State',
		size: 'Size',
		operation: 'operate',
		valid: 'Variable',
		confirm: 'Confirm',
		infoValid: 'The default value of a variable cannot be null',
		infoError: 'Delete the abnormal file first',
		infoLimit: 'Word limit exceeded, please cut content',
		crate: 'Create questions',
		editQ: 'Edit questions',
		nodata: 'There are no shared agents',
		share: 'Shared',
		infoUpload: 'After uploaded,can upload the uploaded files when entering a problem',
		infoSwitch: 'questions contain uploaded files. cannot be disabled',
		selectDisInfo: 'The file has been uploaded in the problem and cannot be deselected',
		deleteInfo: 'After the deletion, all users cannot continue to talk to the agent, and the conversation records are not affected.',
		uploadSuccess: 'Success',
		type: 'Type',
		modelTitle1: 'Do you want to change the knowledge base type?',
		modelInfo2: 'Continue to change the type of the knowledge base. The selected knowledge base becomes invalid',
		uploadText: 'Drag to upload',
		loading: 'Building configuration... ({time}s)',
	},
	search: {
		yayi: 'YAYI',
		search: 'Search',
		change: 'Refresh',
		hot: 'Hot',
		recommend: 'Recommend',
		origin: 'source',
		sendTitle: 'Please enter the question before sending',
		webOrigin: 'Network information source type',
		web: 'Web',
		file: 'File',
		info: 'Please enter content',
		select: 'Select at least one type',
		selectInfo: 'Please select at least one network source',
		webInfo: 'Please Select Source',
		webAll: 'Whole Network',
		originSelect: 'Source',
		webAllInfo: 'Search the whole web for answers',
		originInfo: 'Please select at least one source',
		guess: 'Guess Search',
	},
	longText: {
		loadMessage: 'The writing is long, please wait for a moment, the wonderful is about to appear',
		loading: 'AI generation',
		success: 'Successfully, ready to go',
		link: 'Records > Tasks',
		check: 'View',
		fail: 'Task generation failure',
		fail1: 'There seems to be some problem, please wait and try again',
	},
	share: {
		longWrite: 'Long Text',
		totalWords: 'Total Word：{total}',
	},
	aside: {
		submitSuccess: 'Submit Success',
		submitFail: 'Submit Fail',
		expandMenu:'Expand',
		collapseMenu:'Collapse',
		going: 'working...',
		nodata: 'Nothing...',
		aboutsUs: 'About Us',
		system: 'System',
		system1: 'System Theme',
		light: 'Quantum White',
		dark: 'Dark Matter',
		wait: 'Loading',
		time: 'Est {time} h',
		useGuide:'Tutorials',
		questionnaire: 'FeedBack',
		feedback: 'Send Feedback',
		awaiting: 'Pending',
		theme:'Theme',
		billing:'Available Coins',
		rightsRedeem:'Benefit Redemption',
		personal:'User Center',
		moreInfo:'More Information',
		rulesAgreements: 'Rules & Agreements',
		upgrade:'Upgrade',
		joinEventsGetCoins: 'Join events and get coins!',
		expires: 'Expires',
        lifetimeMembership: 'Lifetime Access',
		renew: 'Renew',
		task: "New User Tasks",
		taskDesc: "Limited-time Coin Event: Earn up to ",
		taskDesc2: "Coins!",
		survey: 'Survey',
		surveyDesc: 'To better serve your research work, we sincerely invite you to participate in this survey.',
		checkTips: 'Please select at least one option',
		fillTip: 'Please fill in the content',
		team: 'ScienceOne Product Team',
		next: 'Next',
		previous: 'Previous',
		submit: "Submit",
		placeholder: 'Please enter your suggestions or comments here (500 words limit)',
		newTaskTip: 'New User Tasks are available! Complete them to get Coin.',
		checkTip: 'Check in today to get xx Coins.',
		checkTiCioins: 'Coins'
	},
	assiant: {
		title: 'Start Your Research Journey',
		caseTitle: 'Explore Use Cases',
		recommend: 'Recommend',
		deepModel: 'Deep Research',
		deatilSurvey: 'Deep Survey',
		placeHolder: "Ask me anything",
		fillAtLeastOne: 'Please fill in at least one item before submitting',
		survey: 'Academic Sources',
		surveyInfo: 'Academic Journal, Conference Proceedings',
		file: 'Library',
		fileInfo: 'Retrieve data from your library',
		fileInfo1: 'Please select at least one library regarding the product.',
		tools: 'Academic Tools',
		toolsInfo: 'Includes a variety of research tools',
		toolsInfo1: 'Please select at least one tool regarding the product.',
		webSource: 'Web Resources',
		webSourceInfo: 'Academic news & reports',
		more: 'More',
		processing: 'Processing',
		confrimMessage: 'Confirm to continue...',
		report: 'Visualization Report',
		document: 'Document',
		writeSurvey: 'Write a Survey',
		web: 'Create a Webpage',
		ppt: 'Academic PPT',
		poster: 'Academic Poster',
		plan: 'Task Planning',
		goResult: 'Skip to Results',
		preview: 'Preview',
		code: 'Code',
		reset: 'Reset',
		submit: 'Submit',
		inputInfo: 'Enter Keywords by Pressing Enter',
		addTitle: 'Add Subtitle',
		Chapter: 'Chapter {number}',
		addChapter: 'Add Chapter',
		taskInfo: 'Too many tasks in the queue, please wait...',
		cancelTaskInfo: 'Cancel',
		cancelTaskInfo1: 'Queue Canceled',
		cancelTaskInfo2: 'Queue Canceled',
		taskFail: 'Queue Failed',
		analyzing: 'Analyzing:',
		totalSum: '{num} of {totalNum}',
		support: 'Supported by CASIA & Wenge',
		all: 'Select All',
		noData: 'No Data Available',
		selectTool: 'Select Tools',
		dataInfo: 'Collection of Domestic and International Authoritative Paper Databases',
		sourceInfo: 'Planned {number} steps, retrieved {totalNum} info',
		sourceInfoPPT: 'Planned {number} steps',
		time: 'Running for {number} minutes',
		workspace: 'Workspace',
		task: 'Task',
		origin: 'Source',
		files: 'File',
		createInfo: 'Please click the action to view...',
		completed: 'Completed',
		checkView: 'View Process File',
		failInfo: 'orry, an exception occurred during execution, the agent has stopped. Please check your input information or retry.',
		failInfo1: 'System busy, please try again later.',
		terminate: 'User Terminated',
		library: 'Library',
		webResource: 'Web Resources',
		otherData: 'Others',
		brief: 'Brief Information',
		cited: 'Cited',
		uncited: 'Uncited',
		slectInfo: 'Filter by Search Keywords',
		clean: 'Clean Filters',
		processFile: 'Process File',
		result: 'Search Results',
		collapse: 'Collapse Process Files',
		thinking: 'Thought Process',
		All: 'All',
		running: 'Processing',
		run: 'Working',
		leastTime: 'Est',
		finishing: 'Almost Finished',
		minutes: 'min',
		hour: 'h',
		review: 'Review',
		unclassified: 'Unclassified Files',
		allView: 'View All Attachments',
		message: 'Information',
		downLoad: 'Download',
		full: 'Full Screen',
		fold: 'Collapse',
		copyConetnt: 'Copy Full Text',
		copyed: '',
		using: 'using ',
		browser: 'browser',
		search: 'search',
		terminal: 'terminal',
		editor: 'editor',
		mediaViewer: 'media viewer',
		taskRunningTip: 'Task started in background. You can close this page and check results in "History".',
		chart: 'chart',
		unactived: 'unactivated',
		tree: 'Classification Tree',
		add: 'Add',
		noAuth: 'Unauthorized',
		setPlugin: 'Configuration Extension',
		authInfo: 'Please authorize your account to proceed. Click below to continue.',
		finish: 'Task replay completed.',
		taskLoading: 'Replaying task...',
		revivew: 'Review',
		searchLists: 'Search Results List',
		outline: 'Outline',
		resultFile: 'Result File',
		noContent: 'No files yet',
		noSearch: 'New keywords added，waiting to search',
		noPreview: 'Preview not supported.',
		downLoadInfo: 'Please download the file to view its contents',
		excel: 'List',
		titleCapt: 'Title',
		placeHolderTitle: 'Please enter a title...',
		placeHolderRemark: 'Please enter your note...',
		addCurrentCapt: 'Add Sibling Section',
		addSubCapt: 'Add Subsection',
		addNode: 'Add Sibling Node',
		addChat: 'New Chat',
		newDesign: 'New Design',
		newSolve: 'New Solve',
		addSession: 'New conversation',
		shareInfo: 'Share this conversation',
		shareSucessInfo: 'The sharing link has been copied. Share it now!',
		linkeInfo: 'Please select reasons to help us improve.',
		disLikeInfo: 'Please select reasons to help us improve.',
		other: 'Others...',
		record: 'Thanks for submitting!',
		stopChat: 'User Terminated',
		detailInfo: 'Add details',
		think:'Thinking',
		taskProcess:'Task Progress',
		submitted:'No confirmation within the time limit; the system has automatically submitted',
		shareInfo1:'{name}:[{title}]shared with you.Click to view:\n{link}\n —— From [ScienceOne·Literature]',
		deepResearch:'Deep Research',
		deepSurvey:'Deep Survey',
		deepSurvey1:'Deep Survey',
		analysisModel:'Proposal Evaluation',
		reviewModel:'Manuscript Review',
		turboModel:'Turbo Mode',
		illustration:'Academic Illustration',
		noHistory:'No history yet',
		selectLanguage:"Confirm the Survey's writing language:",
		chinese:'Chinese',
		english:'English',
		allHistory: 'All',
		surveyReport:"Survey",
		researchReport:"Research Report",
		aiChatReport:"AI Chat Summary",
		shareInfo2:'Found some useful insights in this conversation with {name} —sharing the link so you can check it out — From [ScienceOne·Literature]\n👉 {link}',
		shareInfo3:'I created an {name} with 「S1-Literature」 Check it out\n👉 {link}',
		shareInfo4:'I generated {name} with「S1-Literature」 ! Take a look\n👉 {link}',
		shareturboModel:'Turbo Mode',
		sharedeepResearch:'Deep Research Mode',
		sharedeepSurvey:'Deep Survey Mode',
		shareImg:'academic visuals',
		sharePPT:'academic PPT',
		sharePoster:'academic Poster',
		uploadPPT: 'Upload academic literature to generate an academic PPT in one click.',
		uploadPoster: 'Upload academic literature, one-click generation of academic Poster',
		uploadPaper: 'Upload scholarly manuscripts and generate peer review feedback with a single click.',
		placeHolderIllustration: 'Describe the academic illustration you want to draw.',
		placeHolderSurvey: 'Enter your research question，get professional survey',
		placeHolderCharge: 'Enter research ideas or upload relevant materials, get evaluative analysis on innovation, necessity, funding rationality and more',
		targetLanguage: 'Language',
		generatePPTFromLiterature: 'Generate PPT based on the following academic literature, output language set to task start[{lang}]',
		generatePosterFromLiterature: 'Generate Poster based on the following academic literature, output language set to task start[{lang}]',
		generatePaper: 'Generate Manuscript Review based on the following academic literature, output language set to task start[{lang}]',
		writeInfo:'Thank you for your contribution. Complete your institution details',
		selectunit:"Complete User Organization",
		unitInfo:'Completing your profile can help us provide precise services. Your information is secure and confidential, please feel free to fill it in.',
		unit:'Institution',
		unitPlaceHold:'Please enter organization name',
		confirm:'Confirm',
		tip:'Warm Reminder',
		unitinfo:'.Institution details are used for verification and service personalisation.',
		unitinfo1:'·If your institution is not listed, enter the full name directly',
		unitinfo2:'·All information is confidential and used only to improve our servicesetry',
		regenerate: 'Regenerate',
		edit:'Edit',
		cancelEdit:'Cancel Edit',
		leastChart:'At least 2 characters needed',
		mostChart:'Up to 100 characters',
		keywordInfo:'At least 1 group of keywords',
		keywordInfo1:'Up to 10 groups of keywords',
		editInfo:'Edit document content in the workspace',
		version:'Version',
		versionInfo:'Original / Updated V1.0',
		editTimeInfo:'文File content can be edited up to 3 times',
		chartInfo:"At least 50 characters needed",
		chartInfo1:"Up to 30,000 characters",
		titleInfo:'Notice',
		deleteInfo:"Delete {number} search results and start regenerating right now?",
		deleteOnly:'Delete only',
		retryNow:'Regenerate',
		saveInfo:'Save changes and regenerate now?',
		cancel:'Cancel',
		rightRegenerate:'Regenerate',
		regenerateFail:'Failed to regenerate. Please try again later',
		contentInfo:'Content cannot be empty',
		view:'View',
		theme:'Color',
		size:"Ratio",
		analysisModelInfo:'Analyze multi-dimensions into evaluation reports',
		reviewModelInfo:'Import academic manuscripts to generate peer review suggestions',
		deepSurveyInfo1:'Review 1000+ papers into literature surveys',
		deepSurveyInfo2:'Analyze thousands of academic sources to build knowledge frameworks',
		deepSurveyInfo3:'Customize outline structure with traceable references and one-click export',
		pptInfo1:'Upload papers to generate slides',
		pptInfo2:'Intelligently extract figures and key insights with traceable sources',
		pptInfo3:'Support online preview and editing for flexible academic scenarios',
		illustrationInfo1:'Describe needs to create academic illustrations',
		illustrationInfo2:'Accurately interpret technical terms across theory, experiments, and data analysis',
		illustrationInfo3:'Refine details through dialogue and export high-resolution figures instantly',
		posterInfo1:'Upload papers to design academic posters',
		agentLoopInfo1:"Agent loop",
		posterInfo2:'Multi-size templates with intelligent layout and professional design standards',
		posterInfo3:'Support online preview and editing to fit various conference requirements',
		setUnitSuccess:'Binding successful',
		uploadInfo:'Upload 1 file(.pdf, .doc, .docx) up to 20MB.',
		uploadInfo1:'Upload 1 file(.pdf, .doc, .docx, .txt, .md) up to 20MB.',
		answerFail:'System busy, please try again later',
		answerTerminated:'User Terminated',
		settingInfo:'Search and settings',
		settingInfo1:'Setting',
		addKeyWords:'Add new keywords',
		moreTotal:'(Up to 10 groups of keywords)',
		keyWordesInfo:"After modifying search keywords,",
		keyWordesInfo1:'a new search will be initiated',
		resetInfo:'Restore',
		deletekeywordsInfo:'Search keywords deleted, and the linked search list removed',
		sciTools:'Tools',
		taskName:"Task Name",
		enterTaskName:'Please enter a task name',
		taskNameInfo:'1-48 characters, consisting of lowercase English letters, numbers, and symbols (- , _). Must start with a letter and end with a letter or number.',
		softType:'Model Format',
		uploadFile:"Upload File",
		fileLoading:'Uploading',
		useManual:"User Manual",
		ctlInfo:"Upload a .ctl file",	
		groInfo:"Upload a .gro file",	
		topInfo:"Upload a .top file",	
		rst7Info:"Upload a .rst7 file",	
		parm7Info:"Upload a .parm7 file",	
		dataFileInfo:"Upload a .data file",	
		inInfo:"Upload a .in file",	
		deleteErrInfo:"Delete failed",
		topReserchLang:"分析该项目材料，基于相关政策、前沿技术，围绕重大需求和战略，从技术先进性、经费合理性、相关建设项目等方面，对该项目开展综合研判。",
		fileErrInfo:"The file format does not meet the requirements, please process it before uploading.",
		newComput:"New Computing",
		skills: 'Skills',
		webSources: 'Online sources',
		literature: 'Scholarly literature',
		networkTools: 'General search results',
		input: 'Please enter',



	},
	survey: {
		title: 'Write a Survey',
		copy: 'Copy',
		chat: 'Chat',
		anno: 'Note',
		guide: 'Guide',
		session: 'Session',
		selectContent: 'Selected Content',
		placeHolder: 'Ask and send...',
		hi: 'Hello',
		welcome: 'I can help you reading this report...',
		terminated: 'User Terminated',
		reference: 'References',
		save: 'Save',
		content: 'Main Content',
		keyWord: 'Keywords',
		objectives: 'Objectives',
		views: 'Core Views',
		support: 'Supports',
		deleteInfo: 'Delete this session ?',
		cancel: 'Cancel',
		confirm: 'Confirm',
		refNet: 'Ref-Net',
		legend: 'Legend',
		count: 'Citation Count',
		positive: 'Positive',
		negative: 'Negative',
		graph: 'Graph',
		timeLine: 'Timeline',
		referenceInfo: 'References',
		current: 'Current',
		citing: 'Citing',
		noneInfo: 'No reviews generated',
		none: 'No',
		write: 'reviews,write one.',
		literatureDetails: 'Details',
		view: 'View',
		add: 'Add',
		type: 'Type',
		keywords: 'Please enter keywords...',
		name: 'Name',
		saveToLibrary: 'Library',
		enterLibraryName: 'Search libraries...',
		update: 'Update',
		hello: 'Hello!',
		welcomeHelp: 'I can help you',
		interpretSummary: 'read this report',
		noteSuccess: 'Note successfully!',
		noteErr: 'Note failed',
		pleaseEnter: 'Please enter...',
		new: 'New',
		addSuccess: 'Add to library success.',
		articleExists: 'Article already exists.',
		selectFolder: 'Please select a folder.',
		delTip: 'Do you want to delete',
		pending: 'Pending',
		running: 'Working',
		success: 'Success',
		fail: 'Failed',
		abort: 'Abort',
		terminatedChat: 'Terminated',
		noMessage: 'No information available'
	},
	result: {
		favorite: 'Favorite',
		type: 'Type',
		search: 'Search',
		model: 'Simulation',
		report: 'V-Report',
		other: 'Others',
		origin: 'Referenced {number} Authoritative Sources',
		reName: 'Rename',
		view: 'View Research',
		delete: 'Delete',
		interpretation: 'Intelligent Interpretation',
		reNameResult: 'Rename',
		deleteInfo: 'Do you want to DELETE this result ?',
		deleteSuccess: 'Deleted',
		processing:'Processing',
		fail:'Task Failed',
		stop:'Task Stoped',
		confirm:'Awaiting Confirmation'	
	},
	writeNotice:{
		info:'🌟 We value your feedback',
		btnInfo:'📩 Share your thoughts',
		title:'A Letter to ScienceOne Users',
		user:'Dear PanShi Users:',
		hi:'Hello!',
		text1:`We sincerely thank you for your attention and support of "Panshi"! Since the product's launch, it has received far greater attention and usage than expected. As usage continues to grow, our system's computing resources are under significant pressure. In particular, when generating the "Academic Review" feature, some users have experienced wait times exceeding 6 hours or task timeouts. For this, we sincerely apologize. `,
		text2:`"Panshi" has completed computing capacity expansion and is fully advancing system upgrades, striving to improve product performance as soon as possible to provide researchers worldwide with a more efficient and smooth user experience. Thank you again for your understanding and patience.`,
		text3:'We sincerely invite you to click the button below to complete the survey. Your valuable feedback will help us continuously optimize the product and make progress. ',
		btnInfo1:'Click here to fill out the survey',
		groupName:'Panshi Product Team'

	},
	notification:{
		all:'All',
		unread:'Unread',
		allReaded:'Read All',
		noReadData:'No Unread Messages',
		read:'Read',
		view:'View',
		info:'{n} Unread Messages. Click to view.',
		messageCenter:'Notification',
	},
	changelog:{
		title:'Release Notes',
	},
	feedback:{
		title:'Submit Feedback',
		info1:'We highly value your feedback and are committed to continuously improving our services. If you have any suggestions, you can reach us via email.',
		// title1:'Feedback Survey',
		// info2:'We regularly compile and analyze survey data to identify product improvement opportunities. Every piece of your feedback is driving our product to become better.',
		// info3:'Survey Link:',
		title2:'Email Feedback',
		info4:'We will reply within 7 business days after receiving your email, providing targeted answers to your specific questions to ensure every question gets a response.',
		info5:'Contact Email:',
		info6:"Thank you for using ScienceOne. Let's work together to create a better academic research experience!"

	},
	basis: {
		subjectClassification: 'Classification',
		all: 'All',
		foundTotalDatabases: '{total} Databases Found',
		searchDatabase: 'Search Database',
		accessMethod: 'Access Method',
		onlineQuery: 'Source Code',
		apiInterface: 'API Interface',
		dataDownload: 'Data Download',
		license: 'License',
		databaseName: 'Database Name',
		subjectCategories: 'Classification',
		title: 'Scientific Database',
		slogan: 'One-stop access to authoritative scientific databases worldwide.',
		inputSearchContent: 'Enter search content',
		scientificData: "Database",
		backToDatabaseList: "Back",
		goToOfficialWebsite: "Official Website",
		share: "Share",
		databaseOverview: "Overview",
		publishingInstitution: "Publishing Institution",
		mainApplicationScenarios: "Application Scenarios",
		copyrightNotice: "Copyright Notice",
		unknownResource: "Unknown Resource",
    shareMessage: "I found an amazing 【{name}】 resource in Science One·Literature and would like to share it with you~ [{url}]",
    copySuccess: "Link Copied"
	},
	news: {
		all: 'All',
		papers: 'Papers',
		news: 'News',
		openAccess: 'Open Access',
		pdf: 'View PDF',
		citationCount: 'Citation Count',
		abstract: 'Abstract',
		filter: 'Filter',
		default: 'Default',
		today: 'Today',
		last3Days: 'Last 3 Days',
		last7Days: 'Last 7 Days',
		last30Days: 'Last 30 Days',
		last6Months: 'Last 6 Months',
		lastYear: 'Last Year',
		addtoLibrary: 'Add to Library',
		minutesAgo: 'Minutes Ago',
		hoursAgo: 'Hours Ago',
		daysAgo: 'Days Ago',
		addedToLibrary: 'Added to Library',
		viewSource: 'View Source',
		academicPPT: 'Academic PPT',
		academicPoster: 'Academic Poster',
		noMoreData: 'No more data available',
	},
	tool: {
		shareMessage: "ScienceOne Sci-Tools：{name} —— {url} ",
		sciTools: "Tools",
		featured: "Recommended",
		all: "All",
		saved: "My Tools",
		searchPlaceholder: "Search All tools...",
		searchTools: 'Search My tools...',
		heaCatalystTitle: "High-Activity HEA Inverse Design Alkaline HER",
		useNow: 'Use now',
		runImmediate: "Run",
		details: 'View Details',
		popular: "Popular",
		scene: 'Scenarios',
		disciplines: 'Disciplines',
		toolCount: "{total} tools found",
		overview: "Overview",
		capabilities: "Capabilities",
		limitations: "Limitations",
		useCases: "Use Cases",
		input: "Input:",
		output: "Output",
		form: "Form",
		running: "Running...",
		complete: "Complete",
		failed: "Failed",
		copy: "Copy",
		download: "Download",
		run: "Run",
		addToolSuccess: "Tool added",
		addToolFailed: "Failed to add tool",
		remove: 'Remove Tool',
		removeToolSuccess: 'Tool removed',
		removeToolFailed: 'Failed to remove tool',
		feature: 'Featured',
		viewAll: 'View All',
		add: 'Add',
		added: 'Added',
		share: 'Copy Link',
		useTools:'Use Tool',
		json:"JSON",
		outPut:'Output:',
		noInputData: 'No data available',
		noData:'No output yet',
		placeHold1:'Please input the number of elements for catalyst design，and the recommended number of alloys',
		placeHold2:'Please enter the partial differential equation to be solved and its boundary conditions.',
		preview:"View Fomula",
		closePreview:'Close',
		outPut1:"Output: ",
		notRun:'Not running',
		heaExample:'Conducting  {name} based on literature',
		equationVariablePlaceholder: 'Enter the value of {name}',
		equationRequired: '{name} is required',
		equationInvalidNumber: '{name} must be a valid number',
		equationSubmitInvalid: 'Please fill in all required fields with valid numbers',

	},
	about:{
		title:'Literature is an intelligent agent system built upon the ScienceOne Scientific Foundation Model. It integrates a massive volume of scientific literatures to assist researchers in performing multi-step in-depth research, mapping out research directions, and writing literature reviews, and other scientific research tasks.',
		title1:'Function Positioning',
		name:'Company/Organizaiton',
		name1:'Institute for Advanced Algorithms Research, Shanghai',
		name2:'Chinese Academy of Sciencess',
		name3:'Products',
		name4:'AI Model',
		name5:'Release Date',
		name6:'Enhanced Scientific Language Comprehension',
		name7:'Research Direction Pillar Generation',
		name8:'Literature Graph Generation',
		name9:'High-Quality Scientific Review Generation',
		name10:'Literature Library and In-depth Literature Reading in Restricted Environments',
		name11:'Degree of Hallucination Reduction',
		low:'Low',
		medium:'Medium',
		high:'High',
		title2:'Core Technology',	
		desc1:'Science Corpus',
		desc3:'We construct a complete set of scientific literature pre-training data with a collection of over 200 million scientific documents (including over 160 million paper abstracts and over 70 million full-text papers), sourced from the National Science Library, Chinese Academy of Sciences, to continue pre-training the scientific foundation model.',
		desc4:'Continue Pre Train',
		desc5:"Based on the DeepSeek-V3/R1-671B model, we conduct continued pre-training on a large corpus of scientific textbooks and literatures. This enhances the model's ability to understand scientific language and supports the comprehension of various scientific modalities such as spectral data, field data, nucleic acids and etc.",
		desc6:'Post Train',
		desc7:"We employ a post-training deep analysis framework that aligns with scientific logic; use Curriculum Learning-based SFT (Supervised Fine-Tuning) to incrementally improve the model's comprehensive scientific reasoning capabilities; and adopt an efficient RL (Reinforcement Learning) training method based on GRPO (Group Relative Policy Optimization) to strengthen the model's adherence in scientific logical reasoning.",
		desc8:'Inference',
		desc9:"We use heuristic breadth-first search to enhance the coverage of literature research surveys, and combine this with iterative depth-first search to deeply seeks papers within certain research direction, enabling a more professional understanding, planning, and execution of scientific tasks. The system automatically plans exploration paths across no less than five authoritative academic sources (Literature Information Center, Google Scholar, arXiv, PubMed, ScienceDirect) and uses the model to automatically measure the relevance between the user's query and the literature data.",
		title3:'Key Advantages',
		info:'Comprehensive Research Assistance',
		info1:'<span class="important">Deep Multidisciplinary Understanding:</span> Integrating multiple disciplines such as Mathematics, Physics, Chemistry, Biology, Materials Science and etc., the system precisely and deeply interprets and analyzes scientific modalities (like equations, figures, tables, and experimental data) and the key points of the literature, achieving in-depth understanding and alignment of terminology, theorems, and models.',
		info2:'<span class="important">Professional Review Writing:</span> The system can automatically preview thousands of literatures. By summarizing while reading and refining while writing, it can generate literature reviews exceeding 40,000 characters in length. The review results are comprehensively evaluated as excellent across four dimensions: structural quality, content coverage, thematic relevance, and criticality, with verifiable and reliable citations.',
		info3:'<span class="important">Literature Innovation Network:</span> Beyond recognized academic evaluation metrics, the system establishes an "Innovation Continuation" chain and a "Knowledge Evolution" graph, guiding the creation and reasoning of new knowledge. This provides an alternative, more "objective and direct" perspective for academic evaluation.',
		info4:'Professional Data and Model Foundation',
		info5:'<span class="important">Massive High-Quality Corpus:</span>Integrating authoritative scientific literature sources from the National Science Library, Chinese Academy of Sciences (approx. 170 million) + Google Scholar (approx. 380 million) + arXiv (2.4 million preprints), the data is updated in real-time to minimize hallucinations and bias, providing a solid data foundation for research.',
		name12:'Source',
		name13:'Data Volume',
		name14:'Data Timeliness',
		name15:'Description',
		value1:'National Science Library, Chinese Academy of Sciences',
		value2:'Approx. 170 million',
		value3:'Irregular dynamic updates',
		value4:'Online API',
		value5:'Google Scholar',
		value6:'Approx. 380 million',
		value7:'Real-time updates',
		value8:'Online API',
		value9:'arXiv',
		value10:'Approx. 2.4 million',
		value11:'Real-time updates, annual growth of ~180k papers',
		value12:'Covers Physics, Computer Science, Mathematics, etc.',
		value13:'Springer',
		value14:'Over 14 million',
		value15:'Real-time updates, covers over 2,200 journals',
		value16:'Covers Science, Technology, and Medicine (STM) and Humanities/Social Sciences',
		value17:'Elsevier',
		value18:'Approx. 91 million',
		value19:'Real-time updates, annual growth of ~500k papers',
		value20:'Covers 240 disciplines in Medicine, Engineering, and Computer Science, etc.',
		value21:'PubMed',
		value22:'Approx. 32 million',
		value23:'Real-time updates, ~3,000 new articles daily',
		value24:'Covers Clinical Medicine, Genetics, etc.',
		value25:'<span class="important">Domain-Specific Large Model:</span> The Scientific Foundation Model demonstrates outstanding performance on academic tasks like GAIA, precisely support research needs.',
		title4:'Main Functions',
		func1:'Research',
		func2:"The Research integrates multiple authoritative data sources ( the National Science Library, Chinese Academy of Sciences, arXiv, etc.) to provide an all-in-one knowledge service for scientific research. Upon inputting a scientific question, the system leverages the ScienceOne Foundation Model's deep understanding of professional content to automatically decompose tasks, filter low-quality information, and generate research results. The Research exclusively uses content from academically certified sources to ensure the reliability of the generated result. To comprehensively assist scientific research, S1 Resarch possesses multiple core capabilities, including cross-disciplinary problem-solving, experimental plannning and etc., and supports generating multimodal interactive results.",
		title5:'Library',
		func4:"The Library helps researchers collecting related scientific literatures and aids in the intensive reading of papers. Leveraging the ScienceOne Foundation Model's precise comprehension of the text, equations, figures, images and etc. within a paper, the system provides researchers a quick grasping of the literature with an one-click-generated research guide. During a intensive reading, it assists researchers in constructing citation networks and identifying authoritative scholars, transforming fragmented literature into an interactive knowledge network for easy organization and review.",
		title6:'Survey',
		func5:"In the Survey, the system automatically collects, processes, and reads thousands of papers within hours, structuring the review's framework and generating a comprehensive and professional review. It adopts a human-computer interactive writing mode, allowing researchers to intervene in the writing process to optimize and generate high-quality reviews, significantly improving the efficiency and quality of writing compared to traditional methods.",
		

		
	},
	// 新手引导
	newUserTutorial:{
		step1Card1Title:'Deep reasearch',
		step1Card1Desc:'More Comprehensive,authoritative answers for any research challenge.',
		step1Card2Title:'Universal File Analysis',
		step1Card2Desc:'Synthesize muilti-format files into effortless, expert understanding.',	
		step1Card3Title:'Source & Output Settings',
		step1Card3Desc:'Customize sources and formats for precise, compliant, ready-to-use results.',
		step2Card1Title:'Topic Evaluation',
		step2Card1Desc:'Leverage 220M+ datasets to pinpoint innovation and secure your research breakthrough.',
		step2Card2Title:'Literature Review',
		step2Card2Desc:'No complex prompts needed. Get a structured, PhD-level review from thousands of papers with one click.',
		step2Card3Title:'AI Manuscript Review',
		step2Card3Desc:'Comprehensive, structured feedback with top-tier insights. Maximize your paper’s acceptance potential.',
		step2Card4Title:'Research Visualization',
		step2Card4Desc:'Turn complex papers into professional figures, slides, and posters. Experience seamless visualization at your fingertips.',
		step3Card1Title:'Research Assistant',
		step3Card1Desc:'Your dedicated AI partner assists in deep reading and precise writing to accelerate high-quality research output.',
		step3Card2Title:'Document Library',
		step3Card2Desc:'Read smarter with AI: extract maximum insights out of single paper and the entire document library.',
		step3Card3Title:'Data and Tools',
		step3Card3Desc:'Integrates trusted databases and analytical tools for end-to-end solutions, ensuring evidence-based research.',
		step3Card4Title:'Scientific Feeds',
		step3Card4Desc:'Track global frontiers and master emerging academic trends.',
		skipTutorial:'Skip Tutorial',
		getStarted:'Get Started',
		next: 'Next',
		previous: 'Previous',
		startTask: 'Start',
		surveyTaskStep1Title: "Select Agent",
		surveyTaskStep1Desc: "Click the button in the bottom function bar and choose your preferred academic agent.It supports multiple creation modes, including Deep Survey, Academic PPT, Academic Illustration, Academic Poster, etc.",
		surveyTaskStep2Title: "Configure Source and Output Language",
		surveyTaskStep2Desc: "In the left panel, you can enable or disable  library, and internet sources. You may also switch the output language (中文 / EN) to flexibly control content sources.",
		surveyTaskStep3Title: "Enter and Submit Your Research Request",
		surveyTaskStep3Desc: "Enter your research needs by describing them in natural language or uploading academic documents in the dialog box. After confirming the details are correct, click the send button in the The Agent will immediately process your request.",
		surveyTaskStep4Title: "View History",
		surveyTaskStep4Desc: "Click History at the left navigation to view all your past research records.  ",
		surveyTaskStep5Title: "Quick Start with Preset Instructions",
		surveyTaskStep5Desc: "Preset instructions are displayed below the dialog box. Click any instruction to fill it into the dialog box and quickly reuse research tasks without retyping. Start exploring now!",
		agentTaskStep1Title: "Select Deep Research",
		agentTaskStep1Desc: "Click the [Deep Research] button in the bottom-left corner of the dialog box to enter deep research mode and address complex research needs.",
		agentTaskStep2Title: "Configure Skills, Source and Output Language",
		agentTaskStep2Desc: "In the left panel, you can choose skills, enable or disable  library, and internet sources. You may also switch the output language (中文 / EN) to flexibly control content sources.",
		// agentTaskStep3Title: "配置信源与输出语言",
		// agentTaskStep3Desc: "在右侧面板中打开或关闭学术资源、文献库、网络资料，并可切换产物的输出语言（中文",
		// agentTaskStep4Title: "发送研究需求",
		// agentTaskStep4Desc: "确认内容无误后，点击右下角发送按钮，AI将立即开始处理您的请求并生成学术内容",
		// agentTaskStep5Title: "查看历史记录",
		// agentTaskStep5Desc: "点击左侧导航顶端的「历史记录」，可以查看您所有的历史研究记录，随时回溯并继续之前的研究方向",
		// agentTaskStep6Title: "使用预置指令快速启动",
		// agentTaskStep6Desc: "对话框下方展示了近期使用的预置指令，点击任意一条即可将其填入对话框，快速回复已有研究任务，无需重新输入，立即开始体验吧",
		// academicTaskStep1Title: "选择学术综述智能体",
		// academicTaskStep1Desc: "点击底部功能栏的「学术综述」按钮，选择您需要的智能体类型。除综述之外，还支持学术PPT、学术配图、学术海报等多种创作模式。",
		academicTaskStep2Title: "Configure Output Language and Color",
		academicTaskStep2Desc: "In the left panel，you can switch the output language (中文 / EN)  and customize the color to flexibly control content style.",
		// academicTaskStep3Title: "配置信源与输出语言",
		// academicTaskStep3Desc: "在右侧面板中打开或关闭学术资源、文献库、网络资料，并可切换产物的输出语言（中文",
		// academicTaskStep4Title: "发送研究需求",
		// academicTaskStep4Desc: "确认内容无误后，点击右下角发送按钮，AI将立即开始处理您的请求并生成学术内容",
		// academicTaskStep5Title: "查看历史记录",
		// academicTaskStep5Desc: "点击左侧导航顶端的「历史记录」，可以查看您所有的历史研究记录，随时回溯并继续之前的研究方向",
		// academicTaskStep6Title: "使用预置指令快速启动",
		// academicTaskStep6Desc: "对话框下方展示了近期使用的预置指令，点击任意一条即可将其填入对话框，快速回复已有研究任务，无需重新输入，立即开始体验吧",
		// illustrationTaskStep1Title: "选择学术综述智能体",
		// illustrationTaskStep1Desc: "点击底部功能栏的「学术综述」按钮，选择您需要的智能体类型。除综述之外，还支持学术PPT、学术配图、学术海报等多种创作模式。",
		illustrationTaskStep2Title: "Configure Output Size",
		illustrationTaskStep2Desc: "In the left panel，you can choose the content size.",
		// illustrationTaskStep3Title: "配置信源与输出语言",
		// illustrationTaskStep3Desc: "在右侧面板中打开或关闭学术资源、文献库、网络资料，并可切换产物的输出语言（中文",
		// illustrationTaskStep4Title: "发送研究需求",
		// illustrationTaskStep4Desc: "确认内容无误后，点击右下角发送按钮，AI将立即开始处理您的请求并生成学术内容",
		// illustrationTaskStep5Title: "查看历史记录",
		// illustrationTaskStep5Desc: "点击左侧导航顶端的「历史记录」，可以查看您所有的历史研究记录，随时回溯并继续之前的研究方向",
		// illustrationTaskStep6Title: "使用预置指令快速启动",
		// illustrationTaskStep6Desc: "对话框下方展示了近期使用的预置指令，点击任意一条即可将其填入对话框，快速回复已有研究任务，无需重新输入，立即开始体验吧",
		// posterTaskStep1Title: "选择学术综述智能体",
		// posterTaskStep1Desc: "点击底部功能栏的「学术综述」按钮，选择您需要的智能体类型。除综述之外，还支持学术PPT、学术配图、学术海报等多种创作模式。",
		posterTaskStep2Title: "Configure Output Language and Color",
		posterTaskStep2Desc: "In the left panel，you can switch the output language (中文 / EN)  and customize the color to flexibly control content style.",
		// posterTaskStep3Title: "配置信源与输出语言",
		// posterTaskStep3Desc: "在右侧面板中打开或关闭学术资源、文献库、网络资料，并可切换产物的输出语言（中文",
		// posterTaskStep4Title: "发送研究需求",
		// posterTaskStep4Desc: "确认内容无误后，点击右下角发送按钮，AI将立即开始处理您的请求并生成学术内容",
		// posterTaskStep5Title: "查看历史记录",
		// posterTaskStep5Desc: "点击左侧导航顶端的「历史记录」，可以查看您所有的历史研究记录，随时回溯并继续之前的研究方向",
		// posterTaskStep6Title: "使用预置指令快速启动",
		// posterTaskStep6Desc: "对话框下方展示了近期使用的预置指令，点击任意一条即可将其填入对话框，快速回复已有研究任务，无需重新输入，立即开始体验吧",
		// researchTaskStep1Title: "选择学术综述智能体",
		// researchTaskStep1Desc: "点击底部功能栏的「学术综述」按钮，选择您需要的智能体类型。除综述之外，还支持学术PPT、学术配图、学术海报等多种创作模式。",
		// researchTaskStep2Title: "输入您的研究需求",
		// researchTaskStep2Desc: "在对话框中用自然语言描述您的研究主题，可包含论文标题、关键词、内容描述等，AI将智能理解并生成对应内容。",
		// researchTaskStep3Title: "配置信源与输出语言",
		// researchTaskStep3Desc: "在右侧面板中打开或关闭学术资源、文献库、网络资料，并可切换产物的输出语言（中文",
		// researchTaskStep4Title: "发送研究需求",
		// researchTaskStep4Desc: "确认内容无误后，点击右下角发送按钮，AI将立即开始处理您的请求并生成学术内容",
		// researchTaskStep5Title: "查看历史记录",
		// researchTaskStep5Desc: "点击左侧导航顶端的「历史记录」，可以查看您所有的历史研究记录，随时回溯并继续之前的研究方向",
		// researchTaskStep6Title: "使用预置指令快速启动",
		// researchTaskStep6Desc: "对话框下方展示了近期使用的预置指令，点击任意一条即可将其填入对话框，快速回复已有研究任务，无需重新输入，立即开始体验吧",
		toolTaskStep1Title: 'Featured Section – High-Quality Tool Recommendations',
		toolTaskStep1Desc: 'The Featured section recommends curated high-quality research tools covering data analysis, visualization, literature management, and more.Click [All] to browse more featured tools.',
		toolTaskStep2Title: 'All Tools – Filter and Search',
		toolTaskStep2Desc: 'Switch to the [All] tab to view all available research tools.You can filter by Disciplines and Scenarios, or use the search box to quickly locate the tools you need for improved efficiency.',
		toolTaskStep3Title: 'My Tools – Quick Access',
		toolTaskStep3Desc: 'Switch to the [My Tools] tab to view all your saved tools.The bookmark function helps you quickly find frequently used tools.',
		// toolTaskStep4Title: '特色智能体 - PDE-Agent',
		// toolTaskStep4Desc: 'PDE-Agent是我们的特色智能体工具，专门用于偏微分方程求解。您可以使用自然语言或LaTeX描述物理问题，系统会自动完成从解析、建模到求解的全流程，并支持思考过程可视化，让复杂的数学问题变得简单易懂。',
		toolTaskStep4Title: 'Banner Section – Popular Tools Display',
		toolTaskStep4Desc: 'The Banner section displays the most popular research tools. You can directly try tool functions, bookmark your favorite tools, and share them with colleagues.For self-developed tools, GitHub open-source access is also provided for easy viewing of source code and technical details.',
		toolTaskStep5Title: 'Preset Instructions – Quick Start',
		toolTaskStep5Desc: 'Click preset instructions to quickly load common partial differential equation examples, such as the 2D Navier–Stokes Equations and Allen–Cahn Equation.Start exploring now!',
		newTask: 'New User Tasks'
	},
	docs:{
		termsofService: 'Terms of Service',
		privacyPolicy:'Privacy Policy',
		institutionalAgreement: 'Institutional Account Activation & Verification Agreement',
		coinRules:'Coin Rules',
	}
};
